// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavBar__headerContainer___lnhht {
    display: flex;
    box-sizing: border-box;
    height: var(--navbar-height);
    position: fixed;
    top: 0;
    background: #ffffff;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    z-index: 2;
    padding-left: 20px;
    padding-right: 20px;
}

.NavBar__border___rn2Zl {
    border-bottom: lightgrey 1px solid;
}

.NavBar__shadow___rwAz3 {
     box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.08);
}

.NavBar__sticknetContainer___v9tD_ {
    text-decoration: none;
    color: var(--primary-color)
}

.NavBar__sticknet___f79HG {
    font-size: 40px;
    font-family: 'Sirin Stencil', sans-serif;
    color: var(--primary-color)
}


.NavBar__headerRightContainer___bmy8x {
    /*padding-right: 10vw;*/
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.NavBar__headerLink___iNHzX {
    text-decoration: none;
    color: #363636;
    margin-right: 30px;
}

.NavBar__headerLink___iNHzX:hover {
    color: #6060FF;
}

.NavBar__icon___i6tN7 {
    color: #363636;
    font-size: 1.5vw;
}

.NavBar__heartIcon___bMz_q {
    font-size: 1.5vw;
}


@media screen and (max-width: 1100px) {
    .NavBar__headerContainer___lnhht {
        height: 8vh;
        display: flex;
        align-items: center;
        padding-bottom: 0;
    }

    .NavBar__stiiick___nqBub {
        /*padding-left: 0;*/
        padding-left: 5vw;
    }

    .NavBar__menuIcon___o5McR {
        width: 30px;
        position: fixed;
        z-index: 2;
        right: 5vw;
        cursor: pointer;
    }

    .NavBar__menuIconLine___M5y6r {
        height: 2px;
        width: 30px;
        display: block;
        background-color: var(--black);
        margin-bottom: 4px;
        transition: transform .2s ease;
    }

    .NavBar__menuIconLineLeft____9Pzf {
        width: 15px;
    }

    .NavBar__menuIconLineRight___i8_qu {
        width: 15px;
        float: right;
    }

    .NavBar__headerContainer___lnhht.NavBar__navActive___d60lb .NavBar__menuIconLine___M5y6r {
        transform: translateX(0px) rotate(-45deg);
    }

    .NavBar__headerContainer___lnhht.NavBar__navActive___d60lb .NavBar__menuIconLineLeft____9Pzf {
        transform: translateX(1px) rotate(45deg);
    }

    .NavBar__headerContainer___lnhht.NavBar__navActive___d60lb .NavBar__menuIconLineRight___i8_qu {
        transform: translateX(-2px) rotate(45deg);
    }

    .NavBar__menuContainer___pMwxe {
        position: fixed;
        top: 8vh;
        background: #ffffff;
        left: 0;
        right: 0;
        /**/
        border-bottom: lightgrey 1px solid;
        display: flex;
        flex-direction: column;
        padding-left: 5vw;
        padding-right: 5vw;
        /**/
        overflow: hidden;
        transition: max-height 1s ease;
    }

    .NavBar__headerLink1___O8r0d {
        padding-top: 3vh;
    }

    .NavBar__icon___i6tN7 {
        font-size: 5vw;
    }

    .NavBar__heartIcon___bMz_q {
        font-size: 5vw;
    }

    .NavBar__headerLink___iNHzX {
        margin-bottom: 3vh;
    }

}
`, "",{"version":3,"sources":["webpack://./src/components/NavBar/NavBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IACf,MAAM;IACN,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;KACK,4CAA4C;AACjD;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC;AACJ;;;AAGA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;AAEvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,UAAU;QACV,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,cAAc;QACd,8BAA8B;QAC9B,kBAAkB;QAClB,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,eAAe;QACf,QAAQ;QACR,mBAAmB;QACnB,OAAO;QACP,QAAQ;QACR,GAAG;QACH,kCAAkC;QAClC,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,kBAAkB;QAClB,GAAG;QACH,gBAAgB;QAChB,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;AAEJ","sourcesContent":[".headerContainer {\n    display: flex;\n    box-sizing: border-box;\n    height: var(--navbar-height);\n    position: fixed;\n    top: 0;\n    background: #ffffff;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    z-index: 2;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.border {\n    border-bottom: lightgrey 1px solid;\n}\n\n.shadow {\n     box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.08);\n}\n\n.sticknetContainer {\n    text-decoration: none;\n    color: var(--primary-color)\n}\n\n.sticknet {\n    font-size: 40px;\n    font-family: 'Sirin Stencil', sans-serif;\n    color: var(--primary-color)\n}\n\n\n.headerRightContainer {\n    /*padding-right: 10vw;*/\n    flex-direction: row;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n}\n\n.headerLink {\n    text-decoration: none;\n    color: #363636;\n    margin-right: 30px;\n}\n\n.headerLink:hover {\n    color: #6060FF;\n}\n\n.icon {\n    color: #363636;\n    font-size: 1.5vw;\n}\n\n.heartIcon {\n    font-size: 1.5vw;\n}\n\n\n@media screen and (max-width: 1100px) {\n    .headerContainer {\n        height: 8vh;\n        display: flex;\n        align-items: center;\n        padding-bottom: 0;\n    }\n\n    .stiiick {\n        /*padding-left: 0;*/\n        padding-left: 5vw;\n    }\n\n    .menuIcon {\n        width: 30px;\n        position: fixed;\n        z-index: 2;\n        right: 5vw;\n        cursor: pointer;\n    }\n\n    .menuIconLine {\n        height: 2px;\n        width: 30px;\n        display: block;\n        background-color: var(--black);\n        margin-bottom: 4px;\n        transition: transform .2s ease;\n    }\n\n    .menuIconLineLeft {\n        width: 15px;\n    }\n\n    .menuIconLineRight {\n        width: 15px;\n        float: right;\n    }\n\n    .headerContainer.navActive .menuIconLine {\n        transform: translateX(0px) rotate(-45deg);\n    }\n\n    .headerContainer.navActive .menuIconLineLeft {\n        transform: translateX(1px) rotate(45deg);\n    }\n\n    .headerContainer.navActive .menuIconLineRight {\n        transform: translateX(-2px) rotate(45deg);\n    }\n\n    .menuContainer {\n        position: fixed;\n        top: 8vh;\n        background: #ffffff;\n        left: 0;\n        right: 0;\n        /**/\n        border-bottom: lightgrey 1px solid;\n        display: flex;\n        flex-direction: column;\n        padding-left: 5vw;\n        padding-right: 5vw;\n        /**/\n        overflow: hidden;\n        transition: max-height 1s ease;\n    }\n\n    .headerLink1 {\n        padding-top: 3vh;\n    }\n\n    .icon {\n        font-size: 5vw;\n    }\n\n    .heartIcon {\n        font-size: 5vw;\n    }\n\n    .headerLink {\n        margin-bottom: 3vh;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `NavBar__headerContainer___lnhht`,
	"border": `NavBar__border___rn2Zl`,
	"shadow": `NavBar__shadow___rwAz3`,
	"sticknetContainer": `NavBar__sticknetContainer___v9tD_`,
	"sticknet": `NavBar__sticknet___f79HG`,
	"headerRightContainer": `NavBar__headerRightContainer___bmy8x`,
	"headerLink": `NavBar__headerLink___iNHzX`,
	"icon": `NavBar__icon___i6tN7`,
	"heartIcon": `NavBar__heartIcon___bMz_q`,
	"stiiick": `NavBar__stiiick___nqBub`,
	"menuIcon": `NavBar__menuIcon___o5McR`,
	"menuIconLine": `NavBar__menuIconLine___M5y6r`,
	"menuIconLineLeft": `NavBar__menuIconLineLeft____9Pzf`,
	"menuIconLineRight": `NavBar__menuIconLineRight___i8_qu`,
	"navActive": `NavBar__navActive___d60lb`,
	"menuContainer": `NavBar__menuContainer___pMwxe`,
	"headerLink1": `NavBar__headerLink1___O8r0d`
};
export default ___CSS_LOADER_EXPORT___;
